// src/components/more/Profile.js
import React, { useState } from 'react';
import { ChevronLeft, Mail, Phone } from 'lucide-react';
import { useAtom } from 'jotai';
import { activeChildDetail, appConstants, parentProfile } from '../../atomstore/store';
import { useRequestProcessor } from '../../requestProcessor';
import { ReloadData } from '../../queryfunctions/queryfunctions';
import SpinnerLoading from '../common/SpinnerLoading';
import { useLocation, useNavigate } from 'react-router-dom';
import MyChildren from './MyChildren';

const Profile = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [parent] = useAtom(parentProfile);
    const [constants] = useAtom(appConstants);
    const [imageError, setImageError] = useState(false);
    const { useQueryWrapper } = useRequestProcessor();
    const [activeChild] = useAtom(activeChildDetail)



    const parentName = parent?.parentName || 'N/A';
    const parentType = parent?.parentType || 'Parent Account';
    const email =
        parent?.parentType?.toLowerCase() === 'mother'
            ? parent?.motherEmail
            : parent?.fatherEmail;
    const phone = parent?.parentPhone || 'N/A';

    const handleBack = () => {
        if (location.state?.from) {
            navigate(location.state.from); // go back to origin
        } else {
            navigate(-1); // fallback
        }
    };
    const reloadData = useQueryWrapper(
        ["reload"],
        () => {
            console.log(
                "[My Profile] Calling API: /parentapp/childLoginReloadDetails ",
                activeChild,
                { child_id: activeChild?.id }
            );

            return ReloadData();
        },
        {
            onSuccess: (data) => {
                console.log("[My Profile] Reload child data response:", data);
            },
        }
    );

    const getFullPath = (constants, path) => {
        let imgString = "";
        if (typeof path === "string" && path.startsWith("https")) {
            imgString = path;
        } else if (typeof path === "string" && path.length === 0) {
            imgString = path;
        } else {
            imgString = constants?.ImagePath + path;
        }

        console.log(imgString);

        return imgString;
    };

    return (
        <div className="fixed inset-0 bg-gray-50 z-50 overflow-y-auto">
            {reloadData.isLoading ? <SpinnerLoading /> : ""}
            {/* Header */}
            <div className="sticky top-0 bg-white border-b p-4 flex items-center space-x-3">
                <button onClick={handleBack}>
                    <ChevronLeft className="w-6 h-6 text-gray-600" />
                </button>
                <h2 className="text-lg font-bold text-gray-800 cursor-pointer" onClick={handleBack}>My Profile</h2>
            </div>

            {/* Body */}
            <div className="p-4 space-y-4">
                {/* Profile Card */}
                <div className="bg-gradient-to-r from-cyan-500 to-blue-600 rounded-2xl p-6 text-white">
                    <div className="flex items-center space-x-4 mb-4">
                        {parent?.parentPhoto && parent?.parentApprovedStatus !== "Inactive" && !imageError ? (
                            <img
                                src={getFullPath(constants, parent.parentPhoto)}
                                alt={parentName}
                                onError={() => setImageError(true)}
                                className="w-20 h-20 rounded-full object-cover border-4 border-white shadow-md"
                            />
                        ) : (
                            <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center text-orange-500 text-3xl font-bold shadow-md">
                                {parentName?.charAt(0)?.toUpperCase() || 'P'}
                            </div>
                        )}

                        <div className='max-w-[200px]'>
                            <h3 className="text-2xl font-bold">{parentName}</h3>
                            <p className="text-orange-100 text-sm">{parentType}</p>
                        </div>
                    </div>
                </div>



                {/* Parent Details */}
                <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
                    {/* <h3 className="font-bold text-gray-800 mb-3">Parent Details</h3> */}
                    <div className="flex items-center justify-between mb-3">
                        <h3 className="font-bold text-gray-800">Parent Details</h3>

                        {/* Animated Refresh Button */}
                        {/* <button
                            onClick={() => reloadData.mutate()}
                            className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition active:scale-95"
                        >
                            <RefreshCw
                                className={`w-5 h-5 text-gray-600 
                ${reloadData.isLoading ? "animate-spin" : ""}`}
                            />
                        </button> */}
                    </div>

                    <div className="space-y-3">
                        <div className="flex items-center space-x-3">
                            <Mail className="w-5 h-5 text-gray-400" />
                            <div>
                                <p className="text-xs text-gray-500">Email</p>
                                <p className="text-sm font-medium text-gray-800">
                                    {email || 'N/A'}
                                </p>
                            </div>
                        </div>
                        <div className="flex items-center space-x-3">
                            <Phone className="w-5 h-5 text-gray-400" />
                            <div>
                                <p className="text-xs text-gray-500">Phone</p>
                                <p className="text-sm font-medium text-gray-800">{phone}</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <MyChildren />



        </div>
    );
};

export default Profile;
